'use strict';

import React from 'react';
import GoogleMapReact from 'google-map-react';
import MdLocalPhone from 'react-icons/lib/md/local-phone';
import MdPhone from 'react-icons/lib/md/phone';
import MdEmail from 'react-icons/lib/md/email';
import { Link } from 'react-router-dom';


require('styles//Footer.css');

const LaborTeamMarker = () => <a href="https://www.google.pt/maps/place/LABOR+TEAM+-+Contabilidade,+Fiscalidade+e+Inform%C3%A1tica+Unipessoal+Lda/@38.7903231,-9.3496793,15z/data=!4m5!3m4!1s0x0:0x204090bf025198a1!8m2!3d38.7903231!4d-9.3496793"><img style={{width: '48px', transform: 'translate(-50%, -100%)'}} src="/static/images/laborteam-mapa.svg" alt=""/></a>;

class FooterComponent extends React.Component {
  static defaultProps = {
    center: {lat: 38.7903231, lng: -9.3496793},
    zoom: 15
  };

  createMapOptions() {
    return {
      styles: [
          {
              'featureType': 'all',
              'elementType': 'labels.text.fill',
              'stylers': [
                  {
                      'color': '#000000'
                  },
                  {
                      'weight': '1.05'
                  }
              ]
          },
          {
              'featureType': 'all',
              'elementType': 'labels.text.stroke',
              'stylers': [
                  {
                      'color': '#ffffff'
                  },
                  {
                      'weight': '1.02'
                  }
              ]
          },
          {
              'featureType': 'administrative.province',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'on'
                  }
              ]
          },
          {
              'featureType': 'landscape',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'on'
                  },
                  {
                      'hue': '#ff0000'
                  },
                  {
                      'saturation': '-100'
                  },
                  {
                      'lightness': '27'
                  }
              ]
          },
          {
              'featureType': 'landscape.man_made',
              'elementType': 'all',
              'stylers': [
                  {
                      'saturation': '-100'
                  },
                  {
                      'lightness': '68'
                  }
              ]
          },
          {
              'featureType': 'landscape.man_made',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'weight': '0.01'
                  },
                  {
                      'saturation': '100'
                  },
                  {
                      'lightness': '-21'
                  },
                  {
                      'color': '#fccc9e'
                  }
              ]
          },
          {
              'featureType': 'poi',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'simplified'
                  },
                  {
                      'saturation': '-100'
                  },
                  {
                      'lightness': '57'
                  },
                  {
                      'gamma': '2.51'
                  }
              ]
          },
          {
              'featureType': 'poi',
              'elementType': 'labels.text',
              'stylers': [
                  {
                      'saturation': '-100'
                  },
                  {
                      'lightness': '-32'
                  }
              ]
          },
          {
              'featureType': 'road',
              'elementType': 'all',
              'stylers': [
                  {
                      'saturation': -100
                  },
                  {
                      'lightness': 45
                  }
              ]
          },
          {
              'featureType': 'road',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'visibility': 'on'
                  },
                  {
                      'color': '#f7f6f5'
                  }
              ]
          },
          {
              'featureType': 'road',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'color': '#facaa3'
                  }
              ]
          },
          {
              'featureType': 'road.highway',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'simplified'
                  },
                  {
                      'saturation': '-100'
                  }
              ]
          },
          {
              'featureType': 'road.highway',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'color': '#ffc59b'
                  }
              ]
          },
          {
              'featureType': 'road.highway',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'color': '#ffb363'
                  }
              ]
          },
          {
              'featureType': 'road.arterial',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'on'
                  },
                  {
                      'saturation': '-100'
                  },
                  {
                      'lightness': '33'
                  }
              ]
          },
          {
              'featureType': 'road.arterial',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'color': '#ffbe71'
                  }
              ]
          },
          {
              'featureType': 'road.arterial',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'color': '#ffdbb6'
                  },
                  {
                      'visibility': 'simplified'
                  }
              ]
          },
          {
              'featureType': 'road.local',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'on'
                  },
                  {
                      'saturation': '-100'
                  },
                  {
                      'lightness': '40'
                  }
              ]
          },
          {
              'featureType': 'road.local',
              'elementType': 'geometry.fill',
              'stylers': [
                  {
                      'color': '#fbe9d4'
                  },
                  {
                      'saturation': '-8'
                  }
              ]
          },
          {
              'featureType': 'road.local',
              'elementType': 'geometry.stroke',
              'stylers': [
                  {
                      'color': '#ffe7d5'
                  },
                  {
                      'weight': '0.84'
                  }
              ]
          },
          {
              'featureType': 'transit',
              'elementType': 'all',
              'stylers': [
                  {
                      'visibility': 'simplified'
                  },
                  {
                      'saturation': '-100'
                  }
              ]
          },
          {
              'featureType': 'water',
              'elementType': 'all',
              'stylers': [
                  {
                      'color': '#ff7900'
                  },
                  {
                      'visibility': 'on'
                  }
              ]
          }
      ]
    }
  }

  render() {
    return (
      <section className="footer-component">
        <div className="grid">
          <div className="map">
            <GoogleMapReact
              bootstrapURLKeys={{
                    key: 'AIzaSyDkx5NxDmMJo2Dg8ySVfG8ktXFfYDIc8Cw',
                    language: 'pt'
                }}
              className="google-map"
              options={this.createMapOptions()}
              style={{
                position: 'absolute',
                top: '0px',
                left: '0px',
                right: '0px',
                bottom: '0px'
              }}
              defaultCenter={this.props.center}
              defaultZoom={this.props.zoom}
            >
              <LaborTeamMarker
                lat={this.props.center.lat}
                lng={this.props.center.lng}
              />
            </GoogleMapReact>
          </div>
          <div className="contacts">
            <h4>Onde Estamos</h4>
            <p>Rua das Eiras, 33 - Loja Esq.ª | 2725-294 Mem Martins (Sintra)</p>
            <p><MdEmail /> <a href="mailto:geral@laborteam.pt">geral@laborteam.pt</a></p>
            <p><MdLocalPhone /> +351 214 328 060<br/><small>Chamada para a rede fixa nacional</small></p>
            <p><MdPhone /> +351 966 041 783<br/><small>Chamada para a rede móvel nacional</small></p>
            <div>
                <br/>
                <Link to="/politica-de-privacidade">Política de Privacidade</Link>
            </div>
            <div>
                <a href="//www.livroreclamacoes.pt/">Livro de Reclamações</a>
            </div>
          </div>
          <div className="news"></div>
        </div>
      </section>
    );
  }
}

FooterComponent.displayName = 'FooterComponent';

// Uncomment properties you need
// FooterComponent.propTypes = {};
// FooterComponent.defaultProps = {};

export default FooterComponent;



// WEBPACK FOOTER //
// ./src/components/FooterComponent.js